const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const getBaseUrl = () => {
  if (!API_BASE_URL) {
    throw new Error("API base URL is not configured. Please set REACT_APP_API_BASE_URL.");
  }
  return API_BASE_URL.endsWith("/") ? API_BASE_URL.slice(0, -1) : API_BASE_URL;
};

const handleResponse = async (response) => {
  const json = await response.json().catch(() => ({}));
  if (!response.ok) {
    const message = json?.message || `HTTP ${response.status}`;
    throw new Error(message);
  }
  if (json && json.success === false) {
    throw new Error(json?.message || "API responded with an error.");
  }
  return json;
};

const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

export const tdsApi = {
  async getAssociateTds({
    page = 1,
    limit = 10,
    month,
    year,
    startDate,
    endDate,
    name
  }) {
    const base = getBaseUrl();
    let url = `${base}/api/reports/associateTds?page=${page}&limit=${limit}`;

    if (month) url += `&month=${encodeURIComponent(month)}`;
    if (year) url += `&year=${encodeURIComponent(year)}`;
    if (startDate) url += `&startDate=${encodeURIComponent(startDate)}`;
    if (endDate) url += `&endDate=${encodeURIComponent(endDate)}`;
    if (name) url += `&name=${encodeURIComponent(name)}`;

    const response = await fetch(url, {
      method: "GET",
      headers: getAuthHeaders(),
    });

    return await handleResponse(response);
  },

  async getTdsSummary({ startDate, endDate }) {
    const base = getBaseUrl();
    let url = `${base}/api/reports/summary`;
    const params = [];
    if (startDate) params.push(`startDate=${encodeURIComponent(startDate)}`);
    if (endDate) params.push(`endDate=${encodeURIComponent(endDate)}`);
    if (params.length) url += `?${params.join("&")}`;

    const response = await fetch(url, {
      method: "GET",
      headers: getAuthHeaders(),
    });

    return await handleResponse(response);
  },

  async downloadTdsReport(filters = {}) {
    const base = getBaseUrl();
    let url = `${base}/api/reports/download`;

    const params = Object.entries(filters)
      .filter(([, v]) => v !== undefined && v !== null && v !== "")
      .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`);

    if (params.length) url += `?${params.join("&")}`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        ...(localStorage.getItem("token")
          ? { Authorization: `Bearer ${localStorage.getItem("token")}` }
          : {}),
      },
    });

    if (!response.ok) {
      throw new Error("Failed to download report");
    }

    return response.blob();
  },
};
